import axios from "@axios";

export default {
  namespaced: true,
  state: {
    items: [],
    //itemsUnits: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((seproban) => ({
        value: seproban.id,
        label: seproban.name,
      }));
    },
    /*getSelectedItemsUnit(state) {
      return state.itemsUnits.map((unit) => ({
        value: unit.id_unit,
        label: unit.description,
      }));
    },*/
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    /*setDataUnit(state, value) {
      state.itemsUnits = value;
    },*/
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/seproban/images", {
        params,
      });

      if (!response.data) {
        return [];
      }
      commit("setData", response.data.data);
      return response.data;
    },
    async downloadZip(_, params) {
      const response = await axios.get("v1/seproban/images/download", {
        params,
        responseType: "blob",
      });
      const disposition = response.headers["content-disposition"] || "";
      const matchedName = disposition.match(/filename="?([^";]+)"?/i);
      const fileName = matchedName?.[1] || "seproban_snapshots.zip";
      const url = window.URL.createObjectURL(response.data);
      const link = document.createElement("a");

      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    },
    /*async getAllUnitsEvent({ commit }, params) {
      const response = await axios.get("v1/seproban/units-event", {params});

      if (!response.data) {
        return [];
      }
      commit("setDataUnit", response.data.data);
      response.data.data;
    },*/
    clear({ commit }) {
      commit("setData", []);
    },
  },
};
